export function reviews() {

    $jq3(".button--go-to-reviews").on("click", function (e) {
        e.preventDefault();

        const headerHeight = $jq3(".header").outerHeight();
        const topOffset = $jq3('.google-reviews-panel').offset().top - headerHeight;

        $jq3('html, body').animate({
            scrollTop: topOffset
        }, 500);
    })

    if (typeof reviewConsentGranted == 'undefined' || reviewConsentGranted == false)
        return;

    var request = {
        placeId: garciaPlaceId,
        fields: ['name', 'review']
    };

    var service = new google.maps.places.PlacesService($jq3('#places-dummy').get(0));
    service.getDetails(request, createReviewObjects);

    function createReviewObjects(place, status) {
        for (var i = 0; i < place.reviews.length; i++) {
            if (place.reviews[i].rating < minimumRatingInclusive)
                continue;

            var newReview = $jq3("<div class='google-reviews__review' style='background-image: url(" + googleLogoPath + ");'><div class='google-reviews__review-inner'><p class='google-reviews__review__name'></p><p class='google-reviews__review__date'></p><div class='google-reviews__review__stars'></div><p class='google-reviews__review__content'></p></div></div>");

            newReview.find(".google-reviews__review__name").html(place.reviews[i].author_name);
            newReview.find(".google-reviews__review__date").html(place.reviews[i].relative_time_description);
            newReview.find(".google-reviews__review__content").html(place.reviews[i].text);

            var starContainer = newReview.find(".google-reviews__review__stars");

            for (var j = 1; j < 6; j++) {
                if (j <= place.reviews[i].rating) {
                    starContainer.append("<div class='google-reviews__review__star'><img alt='Stern' class='star-full' src='" + fullStarPath + "'/></div>");
                } else {
                    starContainer.append("<div class='google-reviews__review__star'><img alt='Stern' class='star-empty' src='" + emptyStarPath + "'/></div>");
                }
            }

            $jq3(".google-reviews").append(newReview);
        }
    }
}